import React from 'react'
import { createStackNavigator } from '@react-navigation/stack'

// import { navigationOptionsDefault } from '../config/navigation'

import SettingsOverviewScreen from '../screens/settings/SettingsOverviewScreen'
import UserChangeEmailScreen from '../screens/settings/UserChangeEmailScreen'
import UserChangePasswordScreen from '../screens/settings/UserChangePasswordScreen'
import { commonScreenOptions } from '../config/navigation'

const Stack = createStackNavigator()

const SettingsNavigator = () => {
  return (
    <Stack.Navigator
      initialRouteName="Settings"
      screenOptions={{ ...commonScreenOptions }}
    >
      <Stack.Screen
        name="Settings"
        component={SettingsOverviewScreen}
        options={{
          headerShown: false,
          title: 'Einstellungen',
        }}
      />
      <Stack.Screen
        name="UserChangeEmail"
        component={UserChangeEmailScreen}
        options={{ title: 'E-Mail-Adresse ändern' }}
      />
      <Stack.Screen
        name="UserChangePassword"
        component={UserChangePasswordScreen}
        options={{ title: 'Passwort ändern' }}
      />
    </Stack.Navigator>
  )
}

export default SettingsNavigator
